import React from "react";
import { motion } from "framer-motion";
import { Target, Eye, Heart } from "lucide-react";
import { VALUES } from "../../data/hseData";

export const Mission = () => {
  const blocks = [
    {
      icon: Target,
      label: "Missão",
      text: "Gerar valor em segurança, saúde, meio ambiente e serviços técnicos, protegendo pessoas, operações e o patrimônio dos clientes.",
    },
    {
      icon: Eye,
      label: "Visão",
      text: "Ser reconhecida como referência em soluções integradas para segurança do trabalho, meio ambiente, serviços críticos, manutenção industrial e resposta a emergências.",
    },
  ];

  return (
    <section data-testid="section-missao" className="relative py-24 sm:py-32 bg-[#081726] border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#2FA36B]" />
              <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
                Identidade
              </span>
            </div>
            <h2 className="font-condensed font-bold uppercase text-4xl sm:text-5xl text-white leading-[0.95] tracking-tight">
              Missão, visão
              <br />
              <span className="text-[#2FA36B]">& valores.</span>
            </h2>
            <p className="mt-6 text-white/65 font-body text-base leading-relaxed max-w-md">
              Princípios que orientam cada decisão técnica, cada operação em campo e cada relacionamento com nossos clientes.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {blocks.map((b, i) => {
              const Icon = b.icon;
              return (
                <motion.div
                  key={b.label}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  data-testid={`mission-block-${b.label.toLowerCase()}`}
                  className="border border-white/10 hover:border-[#2FA36B]/60 bg-[#12283F] p-7 sm:p-8 group transition-colors"
                >
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 bg-[#2FA36B] flex items-center justify-center shrink-0">
                      <Icon size={22} className="text-white" strokeWidth={2} />
                    </div>
                    <div>
                      <p className="font-condensed uppercase text-xs tracking-[0.3em] text-white/40 font-bold mb-3">
                        {b.label}
                      </p>
                      <p className="font-body text-base sm:text-lg text-white leading-relaxed">
                        {b.text}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}

            {/* Values */}
            <div className="border border-white/10 bg-[#12283F] p-7 sm:p-8">
              <div className="flex items-start gap-5 mb-6">
                <div className="w-12 h-12 bg-[#2FA36B] flex items-center justify-center shrink-0">
                  <Heart size={22} className="text-white" strokeWidth={2} />
                </div>
                <p className="font-condensed uppercase text-xs tracking-[0.3em] text-white/40 font-bold pt-3">
                  Valores
                </p>
              </div>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {VALUES.map((v) => (
                  <li key={v} className="flex items-start gap-3 text-white/80 font-body text-sm">
                    <span className="w-1 h-1 bg-[#2FA36B] mt-2 shrink-0" />
                    {v}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
